module.exports = __webpack_public_path__ + "img/vignettes-asso_0004_elisabeth-dornano.cab7a7ce.jpg";